// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3veuA","resendInfoText":"OnGoingPaymentBox_resendInfoText__2s0Fp"};